import React, { useEffect, useState } from "react";
import { Card, Button, Typography, Spin } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useSurveySrv } from "pages/Survey/useSurveySrv";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { portalActions } from "store/portal-slice";
import { useDispatch } from "react-redux";
import { clearLocalStore } from "helpers/localStoreSrv";
import { Grid, theme } from "antd";
import BrandColors from "@brand-colors";
import { LANGUAGES, getLanguageId } from "./../../constants/supported_lang";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import i18n from "i18next";
import whitelabelConfig from "@whitelabel-config";
import DOMPurify from "dompurify";
import { usePageTitle } from "helpers/usePageTitle";
import { useSessionDetailLog } from "helpers/useSessionDetailLog";

const { Title } = Typography;
const { useToken } = theme;
const { useBreakpoint } = Grid;
const Agreement = () => {
  const preferredLanguage = useSelector(
    (state: any) => state.portal.uiState.Language
  );
  const { t } = useTranslation();
  usePageTitle("AGREEMENT.PAGE_TITLE", `Agreement - ${process.env.REACT_APP_PRODUCT}`);
  const dispatch = useDispatch();
  const usState = useSelector((state: any) => state.portal.uiState);
  const authState = useSelector((state: any) => state.portal.authSession);
  const [isRule, setIsRule] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [cnfmText, setCnfmText] = useState("");
  const navigate = useNavigate();
  const { getSurevyData, getLanguageTranslations } = useSurveySrv();
  const { token } = useToken();
  const screens = useBreakpoint();
  const [currentLanguage, setCurrentLanguage] = useState(preferredLanguage);
  const [agreeText, setAgreeText] = useState("");
  const [agreeTextContent, setAgreeTextContent] = useState("");
  const uiState = useSelector((state: any) => state.portal.uiState);
  const [isRightAlign, setIsRightAlign] = useState(false);
  const surveyLanguage = useSelector(
    (state: any) => state.portal.uiState.SurveyLanguage
  );
  const { logSessionDetail } = useSessionDetailLog();

  useEffect(() => {
    logSessionDetail("AgreementViewed");
  }, []);

  const proceedAgreement = () => {
    logSessionDetail("AgreementAccepted");
    dispatch(portalActions.updateAgreementStatus(true));
    navigate("/survey", {
      state: { preferredLanguage: preferredLanguage },
    });
  };
  const getIdByCode = (code: string) => {
    const language = LANGUAGES.find((lang) => lang.code === code);
    return language?.id || null;
  };
  const updateConfirmationsByLang = (
    confirmationText: any,
    langCode: any,
    langData: any
  ) => {
    console.log("langCode", langData);
    const updatedLangData =
      langData.filter((item: any) => item.LanguageCode === langCode) || [];
    const match = updatedLangData.find(
      (item: any) => item.TextCode === confirmationText
    );
    return match ? match.TextValue : confirmationText;
  };
  const agreementTitleColor = whitelabelConfig.uiSettings.titleColorBlack;
  useEffect(() => {
    console.log("uiState.Language", uiState.Language);
    i18n.changeLanguage(uiState.Language);
  }, []);
  useEffect(() => {
    try {
      if (whitelabelConfig.uiSettings.rightAlignedLanguage.includes(surveyLanguage) === true) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e)
      handleErrorNavigation(e, navigate, t);
    }
  }, [isRightAlign]);

  useEffect(() => {
    const fetchSurveyData = async () => {
      try {
        const surveyResponse = await getSurevyData();
        const surveyData = surveyResponse?.data;

        const languageData = await getLanguageTranslations(
          surveyData?.TranslationGroupID,
          getLanguageId(preferredLanguage)
        );
        console.log("languageData", languageData);
        const languageCode = getIdByCode(currentLanguage);

        if (surveyData?.IsRuleBasedSurvey) {
          const surveyJson = await fetch(surveyData?.SurveyUrl).then((res) =>
            res.json()
          );
          const translatedText = updateConfirmationsByLang(
            surveyJson.confirmationText,
            languageCode,
            languageData.data
          );

          setCnfmText(translatedText);
          setIsRule(true);
        } else {
          setIsRule(false);
          const updatedLangData =
            languageData?.data?.filter(
              (item: any) => item.LanguageCode === languageCode
            ) || [];
          const agreeTextRes = updatedLangData.find(
            (item: any) => item.TextCode === process.env.REACT_APP_AGR_TEXT
          );
          // const agreeTextContent = updatedLangData.find(
          //   (item: any) =>
          //     item.TextCode === process.env.REACT_APP_AGREEMENT_CONTENT
          // );
          setAgreeText(agreeTextRes?.TextValue);
          setAgreeTextContent(
            updatedLangData.find(
              (item) =>
                item.TextCode === process.env.REACT_APP_AGREEMENT_CONTENT
            )?.TextValue || ""
          );
          //setAgreeTextContent(agreeTextContent?.TextValue);
        }
      } catch (error) {
        handleErrorNavigation(error, navigate, t);
        console.error(
          "Error fetching survey data or TranslationGroupID",
          error
        );
      } finally {
        setIsLoading(false);
      }
    };

    if (authState?.is_authenticated) {
      fetchSurveyData();
    } else {
      clearLocalStore();
      handleErrorNavigation(new Error("Unauthorized"), navigate, t);
    }
  }, [authState, navigate, t, currentLanguage]);
  const styles = {
    section1: {
      alignItems: "center",
      backgroundColor: BrandColors.BUTTON_BG,
      display: "flex",
      fontSize: screens.md ? token.fontSizeHeading5 : token.fontSizeHeading5,
      color: agreementTitleColor ? agreementTitleColor : token.colorBgContainer,
      padding: screens.md ? `15px` : "10px",
      borderRadius: "5px",
      margin: "0",
      justifyContent: isRightAlign ? "end" : "",
    },
    section: {
      alignItems: "center",
      backgroundColor: token.colorBgContainer,
      display: "flex",
      fontSize: screens.md ? token.fontSizeHeading5 : token.fontSizeHeading5,
      padding: screens.md ? `0` : "0px",
      marginTop: "15px",
    },
    section2: {
      alignItems: "center",
      backgroundColor: token.colorBgContainer,
      display: "flex",
      fontSize: screens.md ? token.fontSizeHeading5 : token.fontSizeHeading5,
      padding: screens.md ? `0` : "0px",
      marginTop: "15px",
      justifyContent: "end",
    },
    section3: {
      alignItems: "center",
      backgroundColor: "#fff",
      display: "flex",
      fontSize: screens.md ? token.fontSizeHeading5 : token.fontSizeHeading5,
      padding: screens.md ? `0` : "0px",
      marginTop: "15px",
      justifyContent: isRightAlign ? "end" : "",
    },
    title1: {
      fontSize: screens.md ? token.fontSizeHeading5 : token.fontSizeHeading5,
      marginTop: "0",
      marginBottom: "0px",
      marginRight: "10px",
    },
    button: {
      backgroundColor: BrandColors.BUTTON_BG,
      borderRadius: "50px",
    },
  };
  const divStyle = isLoading ? styles.section : styles.section3;
  if (isLoading || isRule === null) return <Spin size="large" />;
  console.log("agreeText", agreeText);
  console.log(
    "usState.agreementState?.contentText",
    usState.agreementState?.contentText
  );
  return (
    <div className="row page-wrapper justify-content-md-center">
      <div className="col-md-12 col-sm-12 agreementpage">
        <Card
          className="hc-activity-group hls-container"
          bodyStyle={{ padding: 15 }}
        >
          <div className="card-body">
            {isRule === true ? (
              <div
                role="region"
                aria-label={t("AGREEMENT.AGREE", { defaultValue: "Agreement text" })}
                style={{ textAlign: isRightAlign ? "right" : "left" }}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(cnfmText) }}
              />
            ) : (
              <>
                <div style={styles.section1} className="agreement-header" id="agreement-header" tabIndex={0} role="article">
                  {
                    //   usState.agreementState?.contentText
                    agreeText
                      ? agreeText
                      : t("AGREEMENT.AGREE", {
                          PRODUCT_NAME: process.env.REACT_APP_PRODUCT,
                        })
                  }
                </div>
                <div style={divStyle} id="agree-desc" tabIndex={0} role="article">
                  {uiState.agreementState?.CONTENT_TEXT2 ||
                    agreeTextContent ||
                    t("AGREEMENT_GLOBAL.CONTENT_TEXT2")}
                  {/* {usState.agreementState?.CONTENT_TEXT2
                    ? agreeTextContent
                    : t("AGREEMENT_GLOBAL.CONTENT_TEXT2")} */}
                </div>
              </>
            )}
            <div style={styles.section2}>
              <Title style={styles.title1} id="agree-lable" tabIndex={0} role="article">
                {usState.agreementState?.BUTTON_AGREE_LABLE
                  ? usState.agreementState?.BUTTON_AGREE_LABLE
                  : t("AGREEMENT_GLOBAL.BUTTON_AGREE_LABLE")}
              </Title>
              <Button
                data-testid={"btn-forward1"}
                style={{ verticalAlign: "middle" }}
                type="primary"
                className="btn-fab1 btn-forward1"
                onClick={proceedAgreement}
                style={styles.button}
                id="agree-continue-btn"
              >
                <ArrowRightOutlined />
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Agreement;
